<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>fa-filter</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-switch
            v-model="getLastYearModel"
            label="Année précédente"
            color="#EF9A9A"
          ></v-switch>
        </v-row>
        <v-row dense>
          <v-switch
            v-model="getLastWeekModel"
            label="Semaine précédente"
            color="#ffa600"
          ></v-switch>
        </v-row>
        <v-row dense>
          <v-switch
            color="#003f5c"
            v-model="getCurrentModel"
            label="Vente actuelle"
          ></v-switch>
        </v-row>
        <v-row dense>
          <v-switch
            color="success"
            v-model="getEstimateModel"
            label="Estimation"
          ></v-switch>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-btn block small @click="menu = false">
              Fermer
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "EventCalendarFilter",
  props: {
    lastYear: {
      type: Boolean,
      required: true
    },
    lastWeek: {
      type: Boolean,
      required: true
    },
    current: {
      type: Boolean,
      required: true
    },
    estimate: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getLastYearModel: {
      get() {
        return this.lastYear;
      },
      set(v) {
        this.$emit("update:lastYear", v);
      }
    },
    getLastWeekModel: {
      get() {
        return this.lastWeek;
      },
      set(v) {
        this.$emit("update:lastWeek", v);
      }
    },
    getCurrentModel: {
      get() {
        return this.current;
      },
      set(v) {
        this.$emit("update:current", v);
      }
    },
    getEstimateModel: {
      get() {
        return this.estimate;
      },
      set(v) {
        this.$emit("update:estimate", v);
      }
    }
  },
  data() {
    return {
      menu: false
    };
  }
};
</script>

<style></style>
